module.exports = __webpack_public_path__ + "static/media/webicon.bb21dc8b.svg";